/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthenticatedAdminRouteRouteImport } from "./routes/_authenticated/admin/route"
import { Route as AuthenticatedMeRouteRouteImport } from "./routes/_authenticated/me/route"
import { Route as AuthenticatedOrgRouteRouteImport } from "./routes/_authenticated/org/route"
import { Route as DownloadTokenRouteImport } from "./routes/download.$token"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as ResetPasswordTokenRouteImport } from "./routes/reset-password.$token"
import { Route as AuthenticatedAdminIndexRouteImport } from "./routes/_authenticated/admin/index"
import { Route as AuthenticatedAdminSplatRouteImport } from "./routes/_authenticated/admin/$"
import { Route as AuthenticatedAdminAnalyticsRouteImport } from "./routes/_authenticated/admin/analytics"
import { Route as AuthenticatedAdminAuditRouteImport } from "./routes/_authenticated/admin/audit"
import { Route as AuthenticatedAdminFrameworksRouteImport } from "./routes/_authenticated/admin/frameworks"
import { Route as AuthenticatedAdminReportsRouteImport } from "./routes/_authenticated/admin/reports"
import { Route as AuthenticatedAdminSettingsRouteImport } from "./routes/_authenticated/admin/settings"
import { Route as AuthenticatedAdminSystemRouteImport } from "./routes/_authenticated/admin/system"
import { Route as AuthenticatedMeIndexRouteImport } from "./routes/_authenticated/me/index"
import { Route as AuthenticatedMeSplatRouteImport } from "./routes/_authenticated/me/$"
import { Route as AuthenticatedMeAssetsRouteImport } from "./routes/_authenticated/me/assets"
import { Route as AuthenticatedMeDraftsRouteImport } from "./routes/_authenticated/me/drafts"
import { Route as AuthenticatedMeGrowthRouteImport } from "./routes/_authenticated/me/growth"
import { Route as AuthenticatedMeMomentsRouteImport } from "./routes/_authenticated/me/moments"
import { Route as AuthenticatedMeNotebookRouteImport } from "./routes/_authenticated/me/notebook"
import { Route as AuthenticatedMeSettingsRouteImport } from "./routes/_authenticated/me/settings"
import { Route as AuthenticatedMeTrackerRouteImport } from "./routes/_authenticated/me/tracker"
import { Route as AuthenticatedMeVoiceRouteImport } from "./routes/_authenticated/me/voice"
import { Route as AuthenticatedOrgIndexRouteImport } from "./routes/_authenticated/org/index"
import { Route as AuthenticatedOrgSplatRouteImport } from "./routes/_authenticated/org/$"
import { Route as AuthenticatedOrgAnalyticsRouteImport } from "./routes/_authenticated/org/analytics"
import { Route as AuthenticatedOrgAssetsRouteImport } from "./routes/_authenticated/org/assets"
import { Route as AuthenticatedOrgBrandRouteImport } from "./routes/_authenticated/org/brand"
import { Route as AuthenticatedOrgEmployeesRouteImport } from "./routes/_authenticated/org/employees"
import { Route as AuthenticatedOrgPageRouteImport } from "./routes/_authenticated/org/page"
import { Route as AuthenticatedOrgPlanRouteImport } from "./routes/_authenticated/org/plan"
import { Route as AuthenticatedOrgPromptsRouteImport } from "./routes/_authenticated/org/prompts"
import { Route as AuthenticatedOrgReportsRouteImport } from "./routes/_authenticated/org/reports"
import { Route as AuthenticatedOrgSettingsRouteImport } from "./routes/_authenticated/org/settings"
import { Route as AuthenticatedAdminOrgsIndexRouteImport } from "./routes/_authenticated/admin/orgs/index"
import { Route as AuthenticatedAdminOrgsNewRouteImport } from "./routes/_authenticated/admin/orgs/new"
import { Route as AuthenticatedAdminTemplatesIndexRouteImport } from "./routes/_authenticated/admin/templates/index"
import { Route as AuthenticatedAdminTemplatesTemplateIdRouteImport } from "./routes/_authenticated/admin/templates/$templateId"
import { Route as AuthenticatedAdminOrgsOrgIdIndexRouteImport } from "./routes/_authenticated/admin/orgs/$orgId.index"
import { Route as AuthenticatedAdminOrgsOrgIdBrandRouteImport } from "./routes/_authenticated/admin/orgs/$orgId.brand"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMeRouteRoute = AuthenticatedMeRouteRouteImport.update({
  id: "/me",
  path: "/me",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgRouteRoute = AuthenticatedOrgRouteRouteImport.update({
  id: "/org",
  path: "/org",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const DownloadTokenRoute = DownloadTokenRouteImport.update({
  id: "/download/$token",
  path: "/download/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: "/reset-password/$token",
  path: "/reset-password/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminSplatRoute = AuthenticatedAdminSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminAnalyticsRoute =
  AuthenticatedAdminAnalyticsRouteImport.update({
    id: "/analytics",
    path: "/analytics",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminFrameworksRoute =
  AuthenticatedAdminFrameworksRouteImport.update({
    id: "/frameworks",
    path: "/frameworks",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminReportsRoute =
  AuthenticatedAdminReportsRouteImport.update({
    id: "/reports",
    path: "/reports",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSystemRoute =
  AuthenticatedAdminSystemRouteImport.update({
    id: "/system",
    path: "/system",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedMeIndexRoute = AuthenticatedMeIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeSplatRoute = AuthenticatedMeSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeAssetsRoute = AuthenticatedMeAssetsRouteImport.update({
  id: "/assets",
  path: "/assets",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeDraftsRoute = AuthenticatedMeDraftsRouteImport.update({
  id: "/drafts",
  path: "/drafts",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeGrowthRoute = AuthenticatedMeGrowthRouteImport.update({
  id: "/growth",
  path: "/growth",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeMomentsRoute = AuthenticatedMeMomentsRouteImport.update({
  id: "/moments",
  path: "/moments",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeNotebookRoute = AuthenticatedMeNotebookRouteImport.update({
  id: "/notebook",
  path: "/notebook",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeSettingsRoute = AuthenticatedMeSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeTrackerRoute = AuthenticatedMeTrackerRouteImport.update({
  id: "/tracker",
  path: "/tracker",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedMeVoiceRoute = AuthenticatedMeVoiceRouteImport.update({
  id: "/voice",
  path: "/voice",
  getParentRoute: () => AuthenticatedMeRouteRoute,
} as any)
const AuthenticatedOrgIndexRoute = AuthenticatedOrgIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgSplatRoute = AuthenticatedOrgSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgAnalyticsRoute =
  AuthenticatedOrgAnalyticsRouteImport.update({
    id: "/analytics",
    path: "/analytics",
    getParentRoute: () => AuthenticatedOrgRouteRoute,
  } as any)
const AuthenticatedOrgAssetsRoute = AuthenticatedOrgAssetsRouteImport.update({
  id: "/assets",
  path: "/assets",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgBrandRoute = AuthenticatedOrgBrandRouteImport.update({
  id: "/brand",
  path: "/brand",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgEmployeesRoute =
  AuthenticatedOrgEmployeesRouteImport.update({
    id: "/employees",
    path: "/employees",
    getParentRoute: () => AuthenticatedOrgRouteRoute,
  } as any)
const AuthenticatedOrgPageRoute = AuthenticatedOrgPageRouteImport.update({
  id: "/page",
  path: "/page",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgPlanRoute = AuthenticatedOrgPlanRouteImport.update({
  id: "/plan",
  path: "/plan",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgPromptsRoute = AuthenticatedOrgPromptsRouteImport.update({
  id: "/prompts",
  path: "/prompts",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgReportsRoute = AuthenticatedOrgReportsRouteImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => AuthenticatedOrgRouteRoute,
} as any)
const AuthenticatedOrgSettingsRoute =
  AuthenticatedOrgSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedOrgRouteRoute,
  } as any)
const AuthenticatedAdminOrgsIndexRoute =
  AuthenticatedAdminOrgsIndexRouteImport.update({
    id: "/orgs/",
    path: "/orgs/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrgsNewRoute =
  AuthenticatedAdminOrgsNewRouteImport.update({
    id: "/orgs/new",
    path: "/orgs/new",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminTemplatesIndexRoute =
  AuthenticatedAdminTemplatesIndexRouteImport.update({
    id: "/templates/",
    path: "/templates/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminTemplatesTemplateIdRoute =
  AuthenticatedAdminTemplatesTemplateIdRouteImport.update({
    id: "/templates/$templateId",
    path: "/templates/$templateId",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrgsOrgIdIndexRoute =
  AuthenticatedAdminOrgsOrgIdIndexRouteImport.update({
    id: "/orgs/$orgId/",
    path: "/orgs/$orgId/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrgsOrgIdBrandRoute =
  AuthenticatedAdminOrgsOrgIdBrandRouteImport.update({
    id: "/orgs/$orgId/brand",
    path: "/orgs/$orgId/brand",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/me": typeof AuthenticatedMeRouteRouteWithChildren
  "/org": typeof AuthenticatedOrgRouteRouteWithChildren
  "/download/$token": typeof DownloadTokenRoute
  "/invite/$token": typeof InviteTokenRoute
  "/reset-password/$token": typeof ResetPasswordTokenRoute
  "/admin/$": typeof AuthenticatedAdminSplatRoute
  "/admin/analytics": typeof AuthenticatedAdminAnalyticsRoute
  "/admin/audit": typeof AuthenticatedAdminAuditRoute
  "/admin/frameworks": typeof AuthenticatedAdminFrameworksRoute
  "/admin/reports": typeof AuthenticatedAdminReportsRoute
  "/admin/settings": typeof AuthenticatedAdminSettingsRoute
  "/admin/system": typeof AuthenticatedAdminSystemRoute
  "/me/$": typeof AuthenticatedMeSplatRoute
  "/me/assets": typeof AuthenticatedMeAssetsRoute
  "/me/drafts": typeof AuthenticatedMeDraftsRoute
  "/me/growth": typeof AuthenticatedMeGrowthRoute
  "/me/moments": typeof AuthenticatedMeMomentsRoute
  "/me/notebook": typeof AuthenticatedMeNotebookRoute
  "/me/settings": typeof AuthenticatedMeSettingsRoute
  "/me/tracker": typeof AuthenticatedMeTrackerRoute
  "/me/voice": typeof AuthenticatedMeVoiceRoute
  "/org/$": typeof AuthenticatedOrgSplatRoute
  "/org/analytics": typeof AuthenticatedOrgAnalyticsRoute
  "/org/assets": typeof AuthenticatedOrgAssetsRoute
  "/org/brand": typeof AuthenticatedOrgBrandRoute
  "/org/employees": typeof AuthenticatedOrgEmployeesRoute
  "/org/page": typeof AuthenticatedOrgPageRoute
  "/org/plan": typeof AuthenticatedOrgPlanRoute
  "/org/prompts": typeof AuthenticatedOrgPromptsRoute
  "/org/reports": typeof AuthenticatedOrgReportsRoute
  "/org/settings": typeof AuthenticatedOrgSettingsRoute
  "/admin/": typeof AuthenticatedAdminIndexRoute
  "/me/": typeof AuthenticatedMeIndexRoute
  "/org/": typeof AuthenticatedOrgIndexRoute
  "/admin/orgs/new": typeof AuthenticatedAdminOrgsNewRoute
  "/admin/templates/$templateId": typeof AuthenticatedAdminTemplatesTemplateIdRoute
  "/admin/orgs/": typeof AuthenticatedAdminOrgsIndexRoute
  "/admin/templates/": typeof AuthenticatedAdminTemplatesIndexRoute
  "/admin/orgs/$orgId/brand": typeof AuthenticatedAdminOrgsOrgIdBrandRoute
  "/admin/orgs/$orgId/": typeof AuthenticatedAdminOrgsOrgIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/download/$token": typeof DownloadTokenRoute
  "/invite/$token": typeof InviteTokenRoute
  "/reset-password/$token": typeof ResetPasswordTokenRoute
  "/admin/$": typeof AuthenticatedAdminSplatRoute
  "/admin/analytics": typeof AuthenticatedAdminAnalyticsRoute
  "/admin/audit": typeof AuthenticatedAdminAuditRoute
  "/admin/frameworks": typeof AuthenticatedAdminFrameworksRoute
  "/admin/reports": typeof AuthenticatedAdminReportsRoute
  "/admin/settings": typeof AuthenticatedAdminSettingsRoute
  "/admin/system": typeof AuthenticatedAdminSystemRoute
  "/me/$": typeof AuthenticatedMeSplatRoute
  "/me/assets": typeof AuthenticatedMeAssetsRoute
  "/me/drafts": typeof AuthenticatedMeDraftsRoute
  "/me/growth": typeof AuthenticatedMeGrowthRoute
  "/me/moments": typeof AuthenticatedMeMomentsRoute
  "/me/notebook": typeof AuthenticatedMeNotebookRoute
  "/me/settings": typeof AuthenticatedMeSettingsRoute
  "/me/tracker": typeof AuthenticatedMeTrackerRoute
  "/me/voice": typeof AuthenticatedMeVoiceRoute
  "/org/$": typeof AuthenticatedOrgSplatRoute
  "/org/analytics": typeof AuthenticatedOrgAnalyticsRoute
  "/org/assets": typeof AuthenticatedOrgAssetsRoute
  "/org/brand": typeof AuthenticatedOrgBrandRoute
  "/org/employees": typeof AuthenticatedOrgEmployeesRoute
  "/org/page": typeof AuthenticatedOrgPageRoute
  "/org/plan": typeof AuthenticatedOrgPlanRoute
  "/org/prompts": typeof AuthenticatedOrgPromptsRoute
  "/org/reports": typeof AuthenticatedOrgReportsRoute
  "/org/settings": typeof AuthenticatedOrgSettingsRoute
  "/admin": typeof AuthenticatedAdminIndexRoute
  "/me": typeof AuthenticatedMeIndexRoute
  "/org": typeof AuthenticatedOrgIndexRoute
  "/admin/orgs/new": typeof AuthenticatedAdminOrgsNewRoute
  "/admin/templates/$templateId": typeof AuthenticatedAdminTemplatesTemplateIdRoute
  "/admin/orgs": typeof AuthenticatedAdminOrgsIndexRoute
  "/admin/templates": typeof AuthenticatedAdminTemplatesIndexRoute
  "/admin/orgs/$orgId/brand": typeof AuthenticatedAdminOrgsOrgIdBrandRoute
  "/admin/orgs/$orgId": typeof AuthenticatedAdminOrgsOrgIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/_authenticated/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/_authenticated/me": typeof AuthenticatedMeRouteRouteWithChildren
  "/_authenticated/org": typeof AuthenticatedOrgRouteRouteWithChildren
  "/download/$token": typeof DownloadTokenRoute
  "/invite/$token": typeof InviteTokenRoute
  "/reset-password/$token": typeof ResetPasswordTokenRoute
  "/_authenticated/admin/$": typeof AuthenticatedAdminSplatRoute
  "/_authenticated/admin/analytics": typeof AuthenticatedAdminAnalyticsRoute
  "/_authenticated/admin/audit": typeof AuthenticatedAdminAuditRoute
  "/_authenticated/admin/frameworks": typeof AuthenticatedAdminFrameworksRoute
  "/_authenticated/admin/reports": typeof AuthenticatedAdminReportsRoute
  "/_authenticated/admin/settings": typeof AuthenticatedAdminSettingsRoute
  "/_authenticated/admin/system": typeof AuthenticatedAdminSystemRoute
  "/_authenticated/me/$": typeof AuthenticatedMeSplatRoute
  "/_authenticated/me/assets": typeof AuthenticatedMeAssetsRoute
  "/_authenticated/me/drafts": typeof AuthenticatedMeDraftsRoute
  "/_authenticated/me/growth": typeof AuthenticatedMeGrowthRoute
  "/_authenticated/me/moments": typeof AuthenticatedMeMomentsRoute
  "/_authenticated/me/notebook": typeof AuthenticatedMeNotebookRoute
  "/_authenticated/me/settings": typeof AuthenticatedMeSettingsRoute
  "/_authenticated/me/tracker": typeof AuthenticatedMeTrackerRoute
  "/_authenticated/me/voice": typeof AuthenticatedMeVoiceRoute
  "/_authenticated/org/$": typeof AuthenticatedOrgSplatRoute
  "/_authenticated/org/analytics": typeof AuthenticatedOrgAnalyticsRoute
  "/_authenticated/org/assets": typeof AuthenticatedOrgAssetsRoute
  "/_authenticated/org/brand": typeof AuthenticatedOrgBrandRoute
  "/_authenticated/org/employees": typeof AuthenticatedOrgEmployeesRoute
  "/_authenticated/org/page": typeof AuthenticatedOrgPageRoute
  "/_authenticated/org/plan": typeof AuthenticatedOrgPlanRoute
  "/_authenticated/org/prompts": typeof AuthenticatedOrgPromptsRoute
  "/_authenticated/org/reports": typeof AuthenticatedOrgReportsRoute
  "/_authenticated/org/settings": typeof AuthenticatedOrgSettingsRoute
  "/_authenticated/admin/": typeof AuthenticatedAdminIndexRoute
  "/_authenticated/me/": typeof AuthenticatedMeIndexRoute
  "/_authenticated/org/": typeof AuthenticatedOrgIndexRoute
  "/_authenticated/admin/orgs/new": typeof AuthenticatedAdminOrgsNewRoute
  "/_authenticated/admin/templates/$templateId": typeof AuthenticatedAdminTemplatesTemplateIdRoute
  "/_authenticated/admin/orgs/": typeof AuthenticatedAdminOrgsIndexRoute
  "/_authenticated/admin/templates/": typeof AuthenticatedAdminTemplatesIndexRoute
  "/_authenticated/admin/orgs/$orgId/brand": typeof AuthenticatedAdminOrgsOrgIdBrandRoute
  "/_authenticated/admin/orgs/$orgId/": typeof AuthenticatedAdminOrgsOrgIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/forgot-password"
    | "/login"
    | "/admin"
    | "/me"
    | "/org"
    | "/download/$token"
    | "/invite/$token"
    | "/reset-password/$token"
    | "/admin/$"
    | "/admin/analytics"
    | "/admin/audit"
    | "/admin/frameworks"
    | "/admin/reports"
    | "/admin/settings"
    | "/admin/system"
    | "/me/$"
    | "/me/assets"
    | "/me/drafts"
    | "/me/growth"
    | "/me/moments"
    | "/me/notebook"
    | "/me/settings"
    | "/me/tracker"
    | "/me/voice"
    | "/org/$"
    | "/org/analytics"
    | "/org/assets"
    | "/org/brand"
    | "/org/employees"
    | "/org/page"
    | "/org/plan"
    | "/org/prompts"
    | "/org/reports"
    | "/org/settings"
    | "/admin/"
    | "/me/"
    | "/org/"
    | "/admin/orgs/new"
    | "/admin/templates/$templateId"
    | "/admin/orgs/"
    | "/admin/templates/"
    | "/admin/orgs/$orgId/brand"
    | "/admin/orgs/$orgId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/forgot-password"
    | "/login"
    | "/download/$token"
    | "/invite/$token"
    | "/reset-password/$token"
    | "/admin/$"
    | "/admin/analytics"
    | "/admin/audit"
    | "/admin/frameworks"
    | "/admin/reports"
    | "/admin/settings"
    | "/admin/system"
    | "/me/$"
    | "/me/assets"
    | "/me/drafts"
    | "/me/growth"
    | "/me/moments"
    | "/me/notebook"
    | "/me/settings"
    | "/me/tracker"
    | "/me/voice"
    | "/org/$"
    | "/org/analytics"
    | "/org/assets"
    | "/org/brand"
    | "/org/employees"
    | "/org/page"
    | "/org/plan"
    | "/org/prompts"
    | "/org/reports"
    | "/org/settings"
    | "/admin"
    | "/me"
    | "/org"
    | "/admin/orgs/new"
    | "/admin/templates/$templateId"
    | "/admin/orgs"
    | "/admin/templates"
    | "/admin/orgs/$orgId/brand"
    | "/admin/orgs/$orgId"
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/forgot-password"
    | "/login"
    | "/_authenticated/admin"
    | "/_authenticated/me"
    | "/_authenticated/org"
    | "/download/$token"
    | "/invite/$token"
    | "/reset-password/$token"
    | "/_authenticated/admin/$"
    | "/_authenticated/admin/analytics"
    | "/_authenticated/admin/audit"
    | "/_authenticated/admin/frameworks"
    | "/_authenticated/admin/reports"
    | "/_authenticated/admin/settings"
    | "/_authenticated/admin/system"
    | "/_authenticated/me/$"
    | "/_authenticated/me/assets"
    | "/_authenticated/me/drafts"
    | "/_authenticated/me/growth"
    | "/_authenticated/me/moments"
    | "/_authenticated/me/notebook"
    | "/_authenticated/me/settings"
    | "/_authenticated/me/tracker"
    | "/_authenticated/me/voice"
    | "/_authenticated/org/$"
    | "/_authenticated/org/analytics"
    | "/_authenticated/org/assets"
    | "/_authenticated/org/brand"
    | "/_authenticated/org/employees"
    | "/_authenticated/org/page"
    | "/_authenticated/org/plan"
    | "/_authenticated/org/prompts"
    | "/_authenticated/org/reports"
    | "/_authenticated/org/settings"
    | "/_authenticated/admin/"
    | "/_authenticated/me/"
    | "/_authenticated/org/"
    | "/_authenticated/admin/orgs/new"
    | "/_authenticated/admin/templates/$templateId"
    | "/_authenticated/admin/orgs/"
    | "/_authenticated/admin/templates/"
    | "/_authenticated/admin/orgs/$orgId/brand"
    | "/_authenticated/admin/orgs/$orgId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  DownloadTokenRoute: typeof DownloadTokenRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/admin": {
      id: "/_authenticated/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/me": {
      id: "/_authenticated/me"
      path: "/me"
      fullPath: "/me"
      preLoaderRoute: typeof AuthenticatedMeRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/org": {
      id: "/_authenticated/org"
      path: "/org"
      fullPath: "/org"
      preLoaderRoute: typeof AuthenticatedOrgRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/download/$token": {
      id: "/download/$token"
      path: "/download/$token"
      fullPath: "/download/$token"
      preLoaderRoute: typeof DownloadTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password/$token": {
      id: "/reset-password/$token"
      path: "/reset-password/$token"
      fullPath: "/reset-password/$token"
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/admin/": {
      id: "/_authenticated/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/$": {
      id: "/_authenticated/admin/$"
      path: "/$"
      fullPath: "/admin/$"
      preLoaderRoute: typeof AuthenticatedAdminSplatRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/analytics": {
      id: "/_authenticated/admin/analytics"
      path: "/analytics"
      fullPath: "/admin/analytics"
      preLoaderRoute: typeof AuthenticatedAdminAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/audit": {
      id: "/_authenticated/admin/audit"
      path: "/audit"
      fullPath: "/admin/audit"
      preLoaderRoute: typeof AuthenticatedAdminAuditRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/frameworks": {
      id: "/_authenticated/admin/frameworks"
      path: "/frameworks"
      fullPath: "/admin/frameworks"
      preLoaderRoute: typeof AuthenticatedAdminFrameworksRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/reports": {
      id: "/_authenticated/admin/reports"
      path: "/reports"
      fullPath: "/admin/reports"
      preLoaderRoute: typeof AuthenticatedAdminReportsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/settings": {
      id: "/_authenticated/admin/settings"
      path: "/settings"
      fullPath: "/admin/settings"
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/system": {
      id: "/_authenticated/admin/system"
      path: "/system"
      fullPath: "/admin/system"
      preLoaderRoute: typeof AuthenticatedAdminSystemRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/me/": {
      id: "/_authenticated/me/"
      path: "/"
      fullPath: "/me/"
      preLoaderRoute: typeof AuthenticatedMeIndexRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/$": {
      id: "/_authenticated/me/$"
      path: "/$"
      fullPath: "/me/$"
      preLoaderRoute: typeof AuthenticatedMeSplatRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/assets": {
      id: "/_authenticated/me/assets"
      path: "/assets"
      fullPath: "/me/assets"
      preLoaderRoute: typeof AuthenticatedMeAssetsRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/drafts": {
      id: "/_authenticated/me/drafts"
      path: "/drafts"
      fullPath: "/me/drafts"
      preLoaderRoute: typeof AuthenticatedMeDraftsRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/growth": {
      id: "/_authenticated/me/growth"
      path: "/growth"
      fullPath: "/me/growth"
      preLoaderRoute: typeof AuthenticatedMeGrowthRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/moments": {
      id: "/_authenticated/me/moments"
      path: "/moments"
      fullPath: "/me/moments"
      preLoaderRoute: typeof AuthenticatedMeMomentsRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/notebook": {
      id: "/_authenticated/me/notebook"
      path: "/notebook"
      fullPath: "/me/notebook"
      preLoaderRoute: typeof AuthenticatedMeNotebookRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/settings": {
      id: "/_authenticated/me/settings"
      path: "/settings"
      fullPath: "/me/settings"
      preLoaderRoute: typeof AuthenticatedMeSettingsRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/tracker": {
      id: "/_authenticated/me/tracker"
      path: "/tracker"
      fullPath: "/me/tracker"
      preLoaderRoute: typeof AuthenticatedMeTrackerRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/me/voice": {
      id: "/_authenticated/me/voice"
      path: "/voice"
      fullPath: "/me/voice"
      preLoaderRoute: typeof AuthenticatedMeVoiceRouteImport
      parentRoute: typeof AuthenticatedMeRouteRoute
    }
    "/_authenticated/org/": {
      id: "/_authenticated/org/"
      path: "/"
      fullPath: "/org/"
      preLoaderRoute: typeof AuthenticatedOrgIndexRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/$": {
      id: "/_authenticated/org/$"
      path: "/$"
      fullPath: "/org/$"
      preLoaderRoute: typeof AuthenticatedOrgSplatRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/analytics": {
      id: "/_authenticated/org/analytics"
      path: "/analytics"
      fullPath: "/org/analytics"
      preLoaderRoute: typeof AuthenticatedOrgAnalyticsRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/assets": {
      id: "/_authenticated/org/assets"
      path: "/assets"
      fullPath: "/org/assets"
      preLoaderRoute: typeof AuthenticatedOrgAssetsRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/brand": {
      id: "/_authenticated/org/brand"
      path: "/brand"
      fullPath: "/org/brand"
      preLoaderRoute: typeof AuthenticatedOrgBrandRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/employees": {
      id: "/_authenticated/org/employees"
      path: "/employees"
      fullPath: "/org/employees"
      preLoaderRoute: typeof AuthenticatedOrgEmployeesRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/page": {
      id: "/_authenticated/org/page"
      path: "/page"
      fullPath: "/org/page"
      preLoaderRoute: typeof AuthenticatedOrgPageRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/plan": {
      id: "/_authenticated/org/plan"
      path: "/plan"
      fullPath: "/org/plan"
      preLoaderRoute: typeof AuthenticatedOrgPlanRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/prompts": {
      id: "/_authenticated/org/prompts"
      path: "/prompts"
      fullPath: "/org/prompts"
      preLoaderRoute: typeof AuthenticatedOrgPromptsRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/reports": {
      id: "/_authenticated/org/reports"
      path: "/reports"
      fullPath: "/org/reports"
      preLoaderRoute: typeof AuthenticatedOrgReportsRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/org/settings": {
      id: "/_authenticated/org/settings"
      path: "/settings"
      fullPath: "/org/settings"
      preLoaderRoute: typeof AuthenticatedOrgSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgRouteRoute
    }
    "/_authenticated/admin/orgs/": {
      id: "/_authenticated/admin/orgs/"
      path: "/orgs"
      fullPath: "/admin/orgs/"
      preLoaderRoute: typeof AuthenticatedAdminOrgsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/orgs/new": {
      id: "/_authenticated/admin/orgs/new"
      path: "/orgs/new"
      fullPath: "/admin/orgs/new"
      preLoaderRoute: typeof AuthenticatedAdminOrgsNewRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/templates/": {
      id: "/_authenticated/admin/templates/"
      path: "/templates"
      fullPath: "/admin/templates/"
      preLoaderRoute: typeof AuthenticatedAdminTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/templates/$templateId": {
      id: "/_authenticated/admin/templates/$templateId"
      path: "/templates/$templateId"
      fullPath: "/admin/templates/$templateId"
      preLoaderRoute: typeof AuthenticatedAdminTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/orgs/$orgId/": {
      id: "/_authenticated/admin/orgs/$orgId/"
      path: "/orgs/$orgId"
      fullPath: "/admin/orgs/$orgId/"
      preLoaderRoute: typeof AuthenticatedAdminOrgsOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/orgs/$orgId/brand": {
      id: "/_authenticated/admin/orgs/$orgId/brand"
      path: "/orgs/$orgId/brand"
      fullPath: "/admin/orgs/$orgId/brand"
      preLoaderRoute: typeof AuthenticatedAdminOrgsOrgIdBrandRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
  }
}

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminSplatRoute: typeof AuthenticatedAdminSplatRoute
  AuthenticatedAdminAnalyticsRoute: typeof AuthenticatedAdminAnalyticsRoute
  AuthenticatedAdminAuditRoute: typeof AuthenticatedAdminAuditRoute
  AuthenticatedAdminFrameworksRoute: typeof AuthenticatedAdminFrameworksRoute
  AuthenticatedAdminReportsRoute: typeof AuthenticatedAdminReportsRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminSystemRoute: typeof AuthenticatedAdminSystemRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminOrgsNewRoute: typeof AuthenticatedAdminOrgsNewRoute
  AuthenticatedAdminTemplatesTemplateIdRoute: typeof AuthenticatedAdminTemplatesTemplateIdRoute
  AuthenticatedAdminOrgsIndexRoute: typeof AuthenticatedAdminOrgsIndexRoute
  AuthenticatedAdminTemplatesIndexRoute: typeof AuthenticatedAdminTemplatesIndexRoute
  AuthenticatedAdminOrgsOrgIdBrandRoute: typeof AuthenticatedAdminOrgsOrgIdBrandRoute
  AuthenticatedAdminOrgsOrgIdIndexRoute: typeof AuthenticatedAdminOrgsOrgIdIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminSplatRoute: AuthenticatedAdminSplatRoute,
    AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,
    AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,
    AuthenticatedAdminFrameworksRoute: AuthenticatedAdminFrameworksRoute,
    AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,
    AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
    AuthenticatedAdminSystemRoute: AuthenticatedAdminSystemRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
    AuthenticatedAdminOrgsNewRoute: AuthenticatedAdminOrgsNewRoute,
    AuthenticatedAdminTemplatesTemplateIdRoute:
      AuthenticatedAdminTemplatesTemplateIdRoute,
    AuthenticatedAdminOrgsIndexRoute: AuthenticatedAdminOrgsIndexRoute,
    AuthenticatedAdminTemplatesIndexRoute:
      AuthenticatedAdminTemplatesIndexRoute,
    AuthenticatedAdminOrgsOrgIdBrandRoute:
      AuthenticatedAdminOrgsOrgIdBrandRoute,
    AuthenticatedAdminOrgsOrgIdIndexRoute:
      AuthenticatedAdminOrgsOrgIdIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedMeRouteRouteChildren {
  AuthenticatedMeSplatRoute: typeof AuthenticatedMeSplatRoute
  AuthenticatedMeAssetsRoute: typeof AuthenticatedMeAssetsRoute
  AuthenticatedMeDraftsRoute: typeof AuthenticatedMeDraftsRoute
  AuthenticatedMeGrowthRoute: typeof AuthenticatedMeGrowthRoute
  AuthenticatedMeMomentsRoute: typeof AuthenticatedMeMomentsRoute
  AuthenticatedMeNotebookRoute: typeof AuthenticatedMeNotebookRoute
  AuthenticatedMeSettingsRoute: typeof AuthenticatedMeSettingsRoute
  AuthenticatedMeTrackerRoute: typeof AuthenticatedMeTrackerRoute
  AuthenticatedMeVoiceRoute: typeof AuthenticatedMeVoiceRoute
  AuthenticatedMeIndexRoute: typeof AuthenticatedMeIndexRoute
}

const AuthenticatedMeRouteRouteChildren: AuthenticatedMeRouteRouteChildren = {
  AuthenticatedMeSplatRoute: AuthenticatedMeSplatRoute,
  AuthenticatedMeAssetsRoute: AuthenticatedMeAssetsRoute,
  AuthenticatedMeDraftsRoute: AuthenticatedMeDraftsRoute,
  AuthenticatedMeGrowthRoute: AuthenticatedMeGrowthRoute,
  AuthenticatedMeMomentsRoute: AuthenticatedMeMomentsRoute,
  AuthenticatedMeNotebookRoute: AuthenticatedMeNotebookRoute,
  AuthenticatedMeSettingsRoute: AuthenticatedMeSettingsRoute,
  AuthenticatedMeTrackerRoute: AuthenticatedMeTrackerRoute,
  AuthenticatedMeVoiceRoute: AuthenticatedMeVoiceRoute,
  AuthenticatedMeIndexRoute: AuthenticatedMeIndexRoute,
}

const AuthenticatedMeRouteRouteWithChildren =
  AuthenticatedMeRouteRoute._addFileChildren(AuthenticatedMeRouteRouteChildren)

interface AuthenticatedOrgRouteRouteChildren {
  AuthenticatedOrgSplatRoute: typeof AuthenticatedOrgSplatRoute
  AuthenticatedOrgAnalyticsRoute: typeof AuthenticatedOrgAnalyticsRoute
  AuthenticatedOrgAssetsRoute: typeof AuthenticatedOrgAssetsRoute
  AuthenticatedOrgBrandRoute: typeof AuthenticatedOrgBrandRoute
  AuthenticatedOrgEmployeesRoute: typeof AuthenticatedOrgEmployeesRoute
  AuthenticatedOrgPageRoute: typeof AuthenticatedOrgPageRoute
  AuthenticatedOrgPlanRoute: typeof AuthenticatedOrgPlanRoute
  AuthenticatedOrgPromptsRoute: typeof AuthenticatedOrgPromptsRoute
  AuthenticatedOrgReportsRoute: typeof AuthenticatedOrgReportsRoute
  AuthenticatedOrgSettingsRoute: typeof AuthenticatedOrgSettingsRoute
  AuthenticatedOrgIndexRoute: typeof AuthenticatedOrgIndexRoute
}

const AuthenticatedOrgRouteRouteChildren: AuthenticatedOrgRouteRouteChildren = {
  AuthenticatedOrgSplatRoute: AuthenticatedOrgSplatRoute,
  AuthenticatedOrgAnalyticsRoute: AuthenticatedOrgAnalyticsRoute,
  AuthenticatedOrgAssetsRoute: AuthenticatedOrgAssetsRoute,
  AuthenticatedOrgBrandRoute: AuthenticatedOrgBrandRoute,
  AuthenticatedOrgEmployeesRoute: AuthenticatedOrgEmployeesRoute,
  AuthenticatedOrgPageRoute: AuthenticatedOrgPageRoute,
  AuthenticatedOrgPlanRoute: AuthenticatedOrgPlanRoute,
  AuthenticatedOrgPromptsRoute: AuthenticatedOrgPromptsRoute,
  AuthenticatedOrgReportsRoute: AuthenticatedOrgReportsRoute,
  AuthenticatedOrgSettingsRoute: AuthenticatedOrgSettingsRoute,
  AuthenticatedOrgIndexRoute: AuthenticatedOrgIndexRoute,
}

const AuthenticatedOrgRouteRouteWithChildren =
  AuthenticatedOrgRouteRoute._addFileChildren(
    AuthenticatedOrgRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedMeRouteRoute: typeof AuthenticatedMeRouteRouteWithChildren
  AuthenticatedOrgRouteRoute: typeof AuthenticatedOrgRouteRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedMeRouteRoute: AuthenticatedMeRouteRouteWithChildren,
  AuthenticatedOrgRouteRoute: AuthenticatedOrgRouteRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  DownloadTokenRoute: DownloadTokenRoute,
  InviteTokenRoute: InviteTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
